import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { hideDialog } from 'store/modules/base/dialog';
import { updateSleepSettings } from 'store/modules/settings';
import { connect } from 'store/modules/base/redux';
import Browser from './Browser';
import PropTypes from 'prop-types';
import Filmstrip from 'util/UI/videolayout/Filmstrip';
import Box from '@mui/material/Box';
import withBoundary from 'component/ErrorBoundary/withBoundary';
const VWBrowser = (props) => {
  const { clientHeight, filmstripVisible, options } = props;
  const HEIGHT_OFFSET = 80;
  const dispatch = useDispatch();
  // const options = _userDevice?.browserOptions[0];
  const baseUrl = options?.specificUrl
    ? options?.url
    : 'https://www.google.com/search?igu=1';

  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  useEffect(() => {
    const localTabs = window.localStorage.getItem('browser-tabs');
    const commonTabs = [
      {
        title: 'Google',
        url: baseUrl,
        stack: [baseUrl],
        id: 0
      }
    ];
    if (localTabs && options?.continueLeftOff) {
      setTabs(JSON.parse(localTabs));
    } else {
      setTabs(commonTabs);
      window.localStorage.setItem('browser-tabs', JSON.stringify(commonTabs));
    }
  }, []);

  const addTab = () => {
    setActiveTab(tabs.length);
    const tabss = [
      ...tabs,
      {
        title: 'Google',
        url: baseUrl,
        stack: [baseUrl],
        id: tabs.length
      }
    ];
    setTabs(tabss);
    window.localStorage.setItem('browser-tabs', JSON.stringify(tabss));
  };
  const getDimensions = () => {
    let height;

    if (filmstripVisible) {
      height = clientHeight - Filmstrip.getFilmstripHeight();
    } else {
      height = clientHeight;
    }
    return {
      '@media (min-width: 800px)': {
        width: `85% !important`,
        height: `${height - HEIGHT_OFFSET}px !important`,
        marginLeft: `${HEIGHT_OFFSET}px`
      }
    };
  };
  const leaveBrowser = () => {
    dispatch(hideDialog('Browser'));
    dispatch(
      updateSleepSettings({
        userBrowserMode: false
      })
    );
  };
  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
      sx={options?.browserStyle === 'overlay' ? getDimensions() : {}}>
      <Browser
        onAddTabPress={addTab}
        onLeave={leaveBrowser}
        style={{}}
        activeTab={activeTab}
        tabs={tabs}
        options={options}
      />
    </Box>
  );
};
/**
 * Maps (parts of) the Redux state to the associated LargeVideo props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
  return {
    clientWidth: state['features/base/responsive-ui'].clientWidth,
    clientHeight: state['features/base/responsive-ui'].clientHeight,
    filmstripVisible: state['features/filmstrip'].visible
  };
}
export default React.memo(connect(_mapStateToProps)(withBoundary(VWBrowser)));
VWBrowser.propTypes = {
  visible: PropTypes.bool,
  filmstripVisible: PropTypes.bool,
  clientWidth: PropTypes.number,
  clientHeight: PropTypes.number,
  options: PropTypes.object
};
